module.exports = __webpack_public_path__ + "static/media/0.cf532a3b.jpg";